module.exports = __webpack_public_path__ + "header_logo-4d6b421a85213e7f0cad6ca442ab73ef.svg";